import { render, staticRenderFns } from "./query-browser.vue?vue&type=template&id=435d7a27&scoped=true"
import script from "./query-browser.vue?vue&type=script&lang=ts"
export * from "./query-browser.vue?vue&type=script&lang=ts"
import style0 from "./query-browser.vue?vue&type=style&index=0&id=435d7a27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435d7a27",
  null
  
)

export default component.exports